import { render, staticRenderFns } from "./ChallengeCreate.vue?vue&type=template&id=0640474a&scoped=true&"
import script from "./ChallengeCreate.vue?vue&type=script&lang=js&"
export * from "./ChallengeCreate.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeCreate.vue?vue&type=style&index=0&id=0640474a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0640474a",
  null
  
)

export default component.exports